const circular = { display: 'flex', justifyContent: 'center', margin: '5rem' };

const styles = {
  circular
};

export default styles;